import { SxProps, Theme } from "@mui/material";

export const gradientText: SxProps<Theme> = {
  background: "linear-gradient(90deg, #3b82f6 0%, #38bdf8 60%, #67e8f9 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
};

export const heroWrapper: SxProps<Theme> = {
  position: "relative",
  overflow: "hidden",
  color: "white",
  minHeight: { xs: "auto", md: "100vh" },
  display: "flex",
  alignItems: "center",
  py: { xs: 12, md: 0 },
  background: "linear-gradient(to bottom, #000000, #080c14)",
};

export const heroVideoOverlay: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(8,12,20,0.28)",
  zIndex: 1,
};

export const heroRadialOverlay: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "radial-gradient(ellipse 75% 65% at 50% 50%, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0) 75%)",
  zIndex: 1,
};

export const heroTopGradient: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "25%",
  background: "linear-gradient(to bottom, rgba(5,10,28,0.20) 0%, rgba(5,10,28,0) 100%)",
  zIndex: 2,
  pointerEvents: "none",
};

export const heroEyebrow: SxProps<Theme> = {
  mb: 4,
  fontSize: { xs: "0.7rem", md: "0.75rem" },
  fontWeight: 600,
  letterSpacing: "0.2em",
  textTransform: "uppercase",
  color: "#38bdf8",
  fontFamily: "'Barlow', sans-serif",
  opacity: 0,
  animation: "fadeUp 0.7s ease forwards",
  animationDelay: "0s",
  "@keyframes fadeUp": {
    from: { opacity: 0, transform: "translateY(28px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
};

export const heroHeadlineBase: SxProps<Theme> = {
  fontSize: { xs: "4.5rem", md: "7rem", lg: "9rem" },
  letterSpacing: "-0.03em",
  lineHeight: 0.95,
  fontWeight: 800,
  mb: 0,
  opacity: 0,
  animation: "fadeUp 0.7s ease forwards",
  animationDelay: "0.2s",
};

export const heroHeadlineGradient: SxProps<Theme> = {
  fontSize: { xs: "4.5rem", md: "7rem", lg: "9rem" },
  letterSpacing: "-0.03em",
  lineHeight: 0.95,
  fontWeight: 800,
  mb: 5,
  background: "linear-gradient(90deg, #3b82f6 0%, #38bdf8 60%, #67e8f9 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
  opacity: 0,
  animation: "fadeUp 0.7s ease forwards",
  animationDelay: "0.4s",
};

export const heroBody: SxProps<Theme> = {
  mb: 6,
  fontWeight: 400,
  color: "rgba(255,255,255,0.82)",
  lineHeight: 1.65,
  fontSize: { xs: "1rem", md: "1.15rem" },
  maxWidth: 620,
  mx: "auto",
  fontFamily: "'Barlow', sans-serif",
  opacity: 0,
  animation: "fadeUp 0.7s ease forwards",
  animationDelay: "0.6s",
};

export const heroButtonsWrapper: SxProps<Theme> = {
  display: "flex",
  gap: 2,
  flexWrap: "wrap",
  justifyContent: "center",
  opacity: 0,
  animation: "fadeUp 0.7s ease forwards",
  animationDelay: "0.8s",
};

export const heroGetQuoteButton: SxProps<Theme> = {
  borderRadius: "50px",
  px: 4,
  py: 1.5,
  bgcolor: "white",
  color: "#0f172a",
  "&:hover": { bgcolor: "rgba(255,255,255,0.88)" },
};

export const heroExploreButton: SxProps<Theme> = {
  color: "#38bdf8",
  bgcolor: "transparent",
  px: 4,
  py: 1.5,
  "&:hover": { bgcolor: "transparent", color: "#7dd3fc" },
};

export const heroScrollIndicator: SxProps<Theme> = {
  position: "absolute",
  bottom: 40,
  left: "50%",
  transform: "translateX(-50%)",
  zIndex: 3,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 0.75,
  cursor: "pointer",
  "@keyframes float": {
    "0%, 100%": { transform: "translateX(-50%) translateY(0)" },
    "50%": { transform: "translateX(-50%) translateY(-8px)" },
  },
  animation: "float 2.4s ease-in-out infinite",
  "&:hover": { opacity: 0.7 },
  transition: "opacity 0.2s",
};

export const heroScrollLabel: SxProps<Theme> = {
  fontSize: "0.65rem",
  fontWeight: 600,
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  color: "rgba(255,255,255,0.5)",
  fontFamily: "'Barlow', sans-serif",
};

export const heroBottomGradient: SxProps<Theme> = {
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "100%",
  height: "200px",
  background: "linear-gradient(to bottom, transparent, #080c14)",
  zIndex: 2,
  pointerEvents: "none",
};

export const productsSectionWrapper: SxProps<Theme> = {
  background: "linear-gradient(to bottom, #FFFFFF, #F7F8FA)",
  minHeight: { xs: "auto", md: "100vh" },
  display: "flex",
  flexDirection: "column",
};

export const productsDivider: SxProps<Theme> = {
  height: "1px",
  background: "linear-gradient(to right, transparent, rgba(0,0,0,0.07), transparent)",
};

export const productsContent: SxProps<Theme> = {
  flex: 1,
  display: "flex",
  alignItems: "center",
  py: { xs: 8, md: 10 },
};

export const productsEyebrow: SxProps<Theme> = {
  mb: 3,
  fontSize: { xs: "0.7rem", md: "0.75rem" },
  fontWeight: 600,
  letterSpacing: "0.2em",
  textTransform: "uppercase",
  color: "#38bdf8",
  fontFamily: "'Barlow', sans-serif",
  opacity: 0,
  animation: "copySlideIn 0.55s cubic-bezier(0.22, 1, 0.36, 1) forwards",
  animationDelay: "0s",
  "@keyframes copySlideIn": {
    from: { opacity: 0, transform: "translateX(-24px)" },
    to: { opacity: 1, transform: "translateX(0)" },
  },
};

export const productsEyebrowNoAnim: SxProps<Theme> = {
  mb: 3,
  fontSize: { xs: "0.7rem", md: "0.75rem" },
  fontWeight: 600,
  letterSpacing: "0.2em",
  textTransform: "uppercase",
  color: "#38bdf8",
  fontFamily: "'Barlow', sans-serif",
  opacity: 0,
  animation: "none",
  animationDelay: "0s",
  "@keyframes copySlideIn": {
    from: { opacity: 0, transform: "translateX(-24px)" },
    to: { opacity: 1, transform: "translateX(0)" },
  },
};

export const productsHeadline: SxProps<Theme> = {
  fontSize: { xs: "3rem", md: "4.5rem", lg: "5.5rem" },
  letterSpacing: "-0.03em",
  lineHeight: 1.1,
  fontWeight: 800,
  mb: 4,
  opacity: 0,
  animation: "copySlideIn 0.55s cubic-bezier(0.22, 1, 0.36, 1) forwards",
  animationDelay: "0.1s",
};

export const productsHeadlineNoAnim: SxProps<Theme> = {
  fontSize: { xs: "3rem", md: "4.5rem", lg: "5.5rem" },
  letterSpacing: "-0.03em",
  lineHeight: 1.1,
  fontWeight: 800,
  mb: 4,
  opacity: 0,
  animation: "none",
  animationDelay: "0.1s",
};

export const productsBody: SxProps<Theme> = {
  mb: 6,
  fontWeight: 400,
  color: "#4A4A4A",
  lineHeight: 1.65,
  fontSize: { xs: "1rem", md: "1.15rem" },
  fontFamily: "'Barlow', sans-serif",
  maxWidth: 520,
  opacity: 0,
  animation: "copySlideIn 0.55s cubic-bezier(0.22, 1, 0.36, 1) forwards",
  animationDelay: "0.2s",
};

export const productsBodyNoAnim: SxProps<Theme> = {
  mb: 6,
  fontWeight: 400,
  color: "#4A4A4A",
  lineHeight: 1.65,
  fontSize: { xs: "1rem", md: "1.15rem" },
  fontFamily: "'Barlow', sans-serif",
  maxWidth: 520,
  opacity: 0,
  animation: "none",
  animationDelay: "0.2s",
};

export const productsSpecsGrid: SxProps<Theme> = {
  opacity: 0,
  animation: "copySlideIn 0.55s cubic-bezier(0.22, 1, 0.36, 1) forwards",
  animationDelay: "0.3s",
};

export const productsSpecsGridNoAnim: SxProps<Theme> = {
  opacity: 0,
  animation: "none",
  animationDelay: "0.3s",
};

export const productsSpecItem: SxProps<Theme> = {
  pt: 3,
  pr: { xs: 0, sm: 3 },
  borderTop: "1px solid rgba(59,130,246,0.25)",
};

export const productsSpecNumber: SxProps<Theme> = {
  fontSize: { xs: "2.5rem", md: "3rem" },
  fontWeight: 800,
  lineHeight: 1,
  mb: 0.75,
  ...({
    background: "linear-gradient(90deg, #3b82f6 0%, #38bdf8 60%, #67e8f9 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  } as Record<string, unknown>),
};

export const productsSpecLabel: SxProps<Theme> = {
  fontSize: "0.7rem",
  fontWeight: 700,
  letterSpacing: "0.15em",
  textTransform: "uppercase",
  color: "#0A0A0A",
  mb: 0.5,
};

export const productsSpecDescription: SxProps<Theme> = {
  fontSize: "0.8rem",
  color: "#666",
  lineHeight: 1.5,
  fontFamily: "'Barlow', sans-serif",
};

export const productsImageContainer: SxProps<Theme> = {
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: { xs: 280, md: 480 },
};

export const productsImageGlow: SxProps<Theme> = {
  position: "absolute",
  width: "70%",
  height: "70%",
  borderRadius: "50%",
  background:
    "radial-gradient(ellipse at center, rgba(59,130,246,0.08) 0%, rgba(59,130,246,0.03) 50%, transparent 75%)",
  filter: "blur(40px)",
  pointerEvents: "none",
};

export const productsImage: SxProps<Theme> = {
  position: "relative",
  zIndex: 1,
  maxWidth: { xs: "75%", md: "85%" },
  maxHeight: { xs: 260, md: 460 },
  objectFit: "contain",
  filter: "drop-shadow(0 8px 24px rgba(0,0,0,0.10))",
};

export const productsNavWrapper: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 2,
  mt: { xs: 6, md: 8 },
};

export const productsNavButtonPrev: SxProps<Theme> = {
  border: "1px solid",
  borderRadius: "50%",
  p: 1,
  "&:hover": {
    borderColor: "rgba(59,130,246,0.4)",
    color: "#3b82f6",
    bgcolor: "transparent",
  },
};

export const productsNavButtonNext: SxProps<Theme> = {
  border: "1px solid",
  borderRadius: "50%",
  p: 1,
  "&:hover": {
    borderColor: "rgba(59,130,246,0.4)",
    color: "#3b82f6",
    bgcolor: "transparent",
  },
};

export const socialProofWrapper: SxProps<Theme> = {
  position: "relative",
  overflow: "hidden",
  py: { xs: 10, md: 14 },
  background: "linear-gradient(to bottom, #F7F8FA, #FFFFFF)",
  display: "flex",
  alignItems: "center",
};

export const socialProofEyebrow: SxProps<Theme> = {
  color: "#38bdf8",
  fontSize: "0.72rem",
  fontWeight: 600,
  letterSpacing: "0.22em",
  textTransform: "uppercase",
  mb: 2,
  opacity: 0,
  animation: "fadeUp 0.7s ease forwards",
  animationDelay: "0s",
  "@keyframes fadeUp": {
    from: { opacity: 0, transform: "translateY(28px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
};

export const socialProofEyebrowNoAnim: SxProps<Theme> = {
  color: "#38bdf8",
  fontSize: "0.72rem",
  fontWeight: 600,
  letterSpacing: "0.22em",
  textTransform: "uppercase",
  mb: 2,
  opacity: 0,
  animation: "none",
  animationDelay: "0s",
  "@keyframes fadeUp": {
    from: { opacity: 0, transform: "translateY(28px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
};

export const socialProofHeadline: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "3rem", md: "5rem", lg: "6.5rem" },
  lineHeight: 1.05,
  color: "#0A0A0A",
  letterSpacing: "-0.03em",
  mb: 3,
  opacity: 0,
  animation: "fadeUp 0.7s ease forwards",
  animationDelay: "0.15s",
};

export const socialProofHeadlineNoAnim: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "3rem", md: "5rem", lg: "6.5rem" },
  lineHeight: 1.05,
  color: "#0A0A0A",
  letterSpacing: "-0.03em",
  mb: 3,
  opacity: 0,
  animation: "none",
  animationDelay: "0.15s",
};

export const socialProofSubheading: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "#4A4A4A",
  fontSize: { xs: "1rem", md: "1.1rem" },
  lineHeight: 1.7,
  maxWidth: 580,
  mx: "auto",
  mb: { xs: 8, md: 10 },
  opacity: 0,
  animation: "fadeUp 0.7s ease forwards",
  animationDelay: "0.3s",
};

export const socialProofSubheadingNoAnim: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "#4A4A4A",
  fontSize: { xs: "1rem", md: "1.1rem" },
  lineHeight: 1.7,
  maxWidth: 580,
  mx: "auto",
  mb: { xs: 8, md: 10 },
  opacity: 0,
  animation: "none",
  animationDelay: "0.3s",
};

export const statCard: SxProps<Theme> = {
  position: "relative",
  overflow: "hidden",
  background: "#FFFFFF",
  border: "1px solid rgba(0,0,0,0.06)",
  borderRadius: "16px",
  p: { xs: 4, md: 5 },
  textAlign: "center",
  transition: "all 0.3s ease",
  boxShadow: "0 2px 20px rgba(0,0,0,0.06)",
  opacity: 0,
  "@keyframes cardEntrance": {
    "0%": { opacity: 0, transform: "translateY(40px) scale(0.92)" },
    "60%": { opacity: 1 },
    "100%": { opacity: 1, transform: "translateY(0) scale(1)" },
  },
  "&:hover": {
    transform: "translateY(-2px)",
    border: "1px solid rgba(0,0,0,0.08)",
    boxShadow: "0 8px 40px rgba(0,0,0,0.1)",
  },
};

export const statCardTopBorder: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "4px",
  background: "linear-gradient(90deg, #3b82f6, #38bdf8, #67e8f9)",
  borderRadius: "16px 16px 0 0",
};

export const statCardValue: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "3rem", md: "3.8rem" },
  background: "linear-gradient(90deg, #3b82f6 0%, #38bdf8 60%, #67e8f9 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
  lineHeight: 1,
  mb: 1.5,
};

export const statCardLabel: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "#666",
  fontSize: "0.8rem",
  fontWeight: 600,
  letterSpacing: "0.12em",
  textTransform: "uppercase",
};

export const financingSectionWrapper: SxProps<Theme> = {
  py: { xs: 8, md: 12 },
  background: "linear-gradient(to bottom, #FFFFFF, #F7F8FA)",
};

export const financingDivider: SxProps<Theme> = {
  height: "1px",
  background: "linear-gradient(to right, transparent, rgba(0,0,0,0.07), transparent)",
  mb: { xs: 8, md: 12 },
  mt: { xs: -8, md: -12 },
};

export const financingEyebrow: SxProps<Theme> = {
  mb: 3,
  fontSize: { xs: "0.7rem", md: "0.75rem" },
  fontWeight: 600,
  letterSpacing: "0.2em",
  textTransform: "uppercase",
  color: "#38bdf8",
  fontFamily: "'Barlow', sans-serif",
};

export const financingHeadline: SxProps<Theme> = {
  mb: 3,
  fontWeight: 800,
  fontSize: { xs: "3rem", md: "4.5rem", lg: "5.5rem" },
  letterSpacing: "-0.03em",
  lineHeight: 1.05,
  color: "#0A0A0A",
};

export const financingBody: SxProps<Theme> = {
  mb: 6,
  fontWeight: 400,
  color: "#4A4A4A",
  lineHeight: 1.65,
  fontSize: { xs: "1rem", md: "1.15rem" },
  fontFamily: "'Barlow', sans-serif",
  maxWidth: 580,
  mx: "auto",
};

export const financingNote: SxProps<Theme> = {
  mb: 3,
  color: "#4A4A4A",
  fontSize: { xs: "1rem", md: "1.15rem" },
  fontFamily: "'Barlow', sans-serif",
  lineHeight: 1.65,
};

export const techStickyPanel: SxProps<Theme> = {
  position: "sticky",
  top: 0,
  height: "100vh",
  display: "flex",
  overflow: "hidden",
  background: "#F7F8FA",
};

export const techCopyPanel: SxProps<Theme> = {
  width: { xs: "100%", md: "50%" },
  display: "flex",
  alignItems: "center",
  px: { xs: 3, md: 8 },
  overflow: "hidden",
};

export const techEyebrow: SxProps<Theme> = {
  fontSize: "0.75rem",
  fontWeight: 600,
  letterSpacing: "0.2em",
  color: "#38bdf8",
  fontFamily: "'Barlow', sans-serif",
  mb: 2,
  textTransform: "uppercase",
};

export const techHeadline: SxProps<Theme> = {
  fontSize: { xs: "3rem", md: "3.5rem", lg: "4.2rem" },
  letterSpacing: "-0.02em",
  lineHeight: 1.15,
  fontWeight: 800,
  mb: 3,
};

export const techBody: SxProps<Theme> = {
  color: "#4A4A4A",
  fontSize: "1.1rem",
  lineHeight: 1.65,
  fontFamily: "'Barlow', sans-serif",
  mb: 4,
};

export const techFeatureList: SxProps<Theme> = {
  m: 0,
  p: 0,
  listStyle: "none",
  mb: 4,
};

export const techFeatureItem: SxProps<Theme> = {
  display: "flex",
  alignItems: "flex-start",
  gap: 1.5,
  mb: 2.5,
};

export const techFeatureCheckbox: SxProps<Theme> = {
  width: 22,
  height: 22,
  borderRadius: "50%",
  background: "rgba(59,130,246,0.1)",
  border: "1px solid rgba(59,130,246,0.3)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  mt: "2px",
};

export const techFeatureTitle: SxProps<Theme> = {
  color: "#0A0A0A",
  fontSize: "1.125rem",
  fontWeight: 700,
  fontFamily: "'Barlow', sans-serif",
  lineHeight: 1.3,
  mb: 0.4,
};

export const techFeatureDescription: SxProps<Theme> = {
  color: "#666",
  fontSize: "1rem",
  fontFamily: "'Barlow', sans-serif",
  lineHeight: 1.5,
};

export const techImagesPanel: SxProps<Theme> = {
  display: { xs: "none", md: "block" },
  width: "50%",
  position: "relative",
  overflow: "hidden",
};

export const techImagesGlow: SxProps<Theme> = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  height: "100%",
  background:
    "radial-gradient(ellipse at center, rgba(59,130,246,0.06) 0%, rgba(56,189,248,0.03) 40%, transparent 72%)",
  pointerEvents: "none",
  zIndex: 0,
  filter: "blur(50px)",
};

export const techProposalFrame: SxProps<Theme> = {
  position: "absolute",
  top: "50%",
  left: "50%",
  width: "100%",
  willChange: "opacity, transform",
  zIndex: 1,
};

export const techProposalImage: SxProps<Theme> = {
  display: "block",
  width: "100%",
  maxHeight: "94vh",
  borderRadius: "12px",
  boxShadow: "0 8px 40px rgba(0,0,0,0.08), 0 2px 16px rgba(0,0,0,0.06)",
  userSelect: "none",
  pointerEvents: "none",
};

export const howItWorksWrapper: SxProps<Theme> = {
  py: { xs: 10, md: 16 },
  position: "relative",
  backgroundImage: "url('/img/assets/hero (1).png')",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
};

export const howItWorksDarkOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background: "rgba(10,15,30,0.45)",
  zIndex: 0,
};

export const howItWorksTopGradient: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  height: "280px",
  background: "linear-gradient(to bottom, #0a0f1e 0%, transparent 100%)",
  zIndex: 1,
  pointerEvents: "none",
};

export const howItWorksBottomGradient: SxProps<Theme> = {
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  height: "180px",
  background: "linear-gradient(to top, #0a0f1e 0%, transparent 100%)",
  zIndex: 1,
  pointerEvents: "none",
};

export const howItWorksEyebrow: SxProps<Theme> = {
  fontSize: "0.7rem",
  fontWeight: 700,
  letterSpacing: "0.2em",
  textTransform: "uppercase",
  color: "#38bdf8",
  fontFamily: "'Barlow', sans-serif",
  mb: 2,
};

export const howItWorksHeadline: SxProps<Theme> = {
  color: "white",
  fontWeight: 800,
  fontSize: { xs: "2.5rem", md: "3.5rem" },
  letterSpacing: "-0.02em",
  lineHeight: 1.15,
  mb: 2,
};

export const howItWorksSubheading: SxProps<Theme> = {
  color: "rgba(255,255,255,0.82)",
  fontSize: { xs: "1.1rem", md: "1.2rem" },
  fontFamily: "'Barlow', sans-serif",
};

export const howItWorksCarouselWrapper: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: { xs: 1, md: 3 },
};

export const howItWorksCarouselViewport: SxProps<Theme> = {
  flex: 1,
  overflow: "hidden",
  position: "relative",
  height: { xs: 280, md: 320 },
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const howItWorksCardBase: SxProps<Theme> = {
  position: "absolute",
  width: { xs: "75%", sm: "55%", md: "38%" },
  maxWidth: 380,
  transition: "opacity 0.4s ease, transform 0.4s ease",
};

export const howItWorksStepNumber: SxProps<Theme> = {
  fontSize: "0.8rem",
  fontWeight: 600,
  letterSpacing: "0.15em",
  fontFamily: "'Barlow', sans-serif",
  mb: 1,
  textTransform: "uppercase",
};

export const howItWorksStepTitle: SxProps<Theme> = {
  color: "white",
  fontWeight: 700,
  fontSize: { xs: "1.15rem", md: "1.25rem" },
  lineHeight: 1.3,
  mb: 1.5,
  fontFamily: "'Barlow', sans-serif",
};

export const howItWorksStepDescription: SxProps<Theme> = {
  color: "rgba(255,255,255,0.5)",
  fontSize: "1rem",
  lineHeight: 1.6,
  fontFamily: "'Barlow', sans-serif",
};

export const howItWorksDots: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  gap: 1,
  mt: 5,
};

export const howItWorksFormWrapper: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 0,
  mt: 6,
  maxWidth: 480,
  mx: "auto",
};

export const howItWorksZipInput: SxProps<Theme> = {
  flex: 1,
  height: 52,
  px: "20px",
  fontSize: "1rem",
  fontFamily: "'Barlow', sans-serif",
  color: "#0a0f1e",
  background: "white",
  border: "none",
  borderRadius: "50px 0 0 50px",
  outline: "none",
  "&::placeholder": { color: "rgba(10,15,30,0.4)" },
  "&:focus": { background: "white" },
};

export const howItWorksSubmitButton: SxProps<Theme> = {
  height: 52,
  px: "24px",
  fontSize: "1rem",
  fontWeight: 700,
  fontFamily: "'Barlow', sans-serif",
  color: "white",
  background: "linear-gradient(90deg, #f97316 0%, #fb923c 100%)",
  border: "none",
  borderRadius: "0 50px 50px 0",
  cursor: "pointer",
  whiteSpace: "nowrap",
  transition: "opacity 0.2s ease",
  "&:hover": { opacity: 0.88 },
};

export const testimonialsWrapper: SxProps<Theme> = {
  position: "relative",
  width: "100%",
  height: { xs: "100svh", md: "90vh" },
  minHeight: { xs: 560, md: 680 },
  overflow: "hidden",
};

export const testimonialsIframe: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  border: "none",
  zIndex: 2,
};

export const testimonialsCloseButton: SxProps<Theme> = {
  position: "absolute",
  top: 16,
  right: 16,
  zIndex: 3,
  width: 40,
  height: 40,
  borderRadius: "50%",
  background: "rgba(0,0,0,0.6)",
  backdropFilter: "blur(6px)",
  border: "1px solid rgba(255,255,255,0.2)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  transition: "background 0.2s ease",
  "&:hover": { background: "rgba(0,0,0,0.85)" },
};

export const testimonialsGradientBottom: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background: "linear-gradient(to top, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.35) 50%, rgba(0,0,0,0.15) 100%)",
  pointerEvents: "none",
};

export const testimonialsGradientLeft: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background: "linear-gradient(to right, rgba(0,0,0,0.55) 0%, transparent 60%)",
  pointerEvents: "none",
};

export const testimonialsPlayOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  "&:hover .play-btn": {
    transform: "scale(1.1)",
    backgroundColor: "rgba(255,255,255,0.22)",
  },
};

export const testimonialsPlayButton: SxProps<Theme> = {
  width: { xs: 68, md: 88 },
  height: { xs: 68, md: 88 },
  borderRadius: "50%",
  border: "2px solid rgba(255,255,255,0.85)",
  backdropFilter: "blur(10px)",
  backgroundColor: "rgba(255,255,255,0.12)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "transform 0.3s ease, background-color 0.3s ease",
};

export const testimonialsInfoPanel: SxProps<Theme> = {
  position: "absolute",
  bottom: { xs: 32, md: 52 },
  left: { xs: 24, md: 52 },
  maxWidth: { xs: "calc(100% - 48px)", md: "50%" },
};

export const testimonialsEyebrow: SxProps<Theme> = {
  color: "#38bdf8",
  fontSize: { xs: "0.65rem", md: "0.72rem" },
  fontWeight: 600,
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  mb: 1,
};

export const testimonialsHeadline: SxProps<Theme> = {
  color: "white",
  fontSize: { xs: "2rem", md: "3rem" },
  fontWeight: 700,
  fontFamily: "'Poppins', sans-serif",
  letterSpacing: "-0.03em",
  lineHeight: 1.1,
  textShadow: "0 4px 24px rgba(0,0,0,0.6)",
  mb: 1.5,
};

export const testimonialsVideoLabel: SxProps<Theme> = {
  color: "white",
  fontWeight: 700,
  fontSize: { xs: "1rem", md: "1.15rem" },
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  lineHeight: 1.3,
};

export const testimonialsVideoDescription: SxProps<Theme> = {
  color: "rgba(255,255,255,0.6)",
  fontSize: { xs: "0.82rem", md: "0.9rem" },
  letterSpacing: "0.01em",
  lineHeight: 1.55,
  mt: 0.75,
  maxWidth: 420,
};

export const testimonialsThumbnailsPanel: SxProps<Theme> = {
  position: "absolute",
  bottom: { xs: 24, md: 40 },
  right: { xs: 16, md: 40 },
  display: "flex",
  flexDirection: "column",
  gap: 1.5,
};

export const testimonialsThumbnail: SxProps<Theme> = {
  position: "relative",
  width: { xs: 160, md: 270 },
  height: { xs: 100, md: 165 },
  borderRadius: "10px",
  overflow: "hidden",
  cursor: "pointer",
  opacity: 0.55,
  border: "1.5px solid rgba(255,255,255,0.12)",
  boxShadow: "0 8px 32px rgba(0,0,0,0.5)",
  transition: "opacity 0.3s ease, transform 0.3s ease, border-color 0.3s ease",
  "&:hover": {
    opacity: 1,
    transform: "scale(1.04)",
    borderColor: "rgba(255,255,255,0.4)",
  },
  "&:hover .thumb-play": { opacity: 1 },
};

export const testimonialsThumbnailGradient: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background: "linear-gradient(to top, rgba(0,0,0,0.8) 0%, transparent 55%)",
};

export const testimonialsThumbnailPlayOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  opacity: 0,
  transition: "opacity 0.3s ease",
};

export const testimonialsThumbnailPlayIcon: SxProps<Theme> = {
  width: 36,
  height: 36,
  borderRadius: "50%",
  border: "1.5px solid rgba(255,255,255,0.8)",
  backdropFilter: "blur(6px)",
  backgroundColor: "rgba(255,255,255,0.12)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const testimonialsThumbnailLabel: SxProps<Theme> = {
  color: "white",
  fontWeight: 700,
  fontSize: "0.68rem",
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  lineHeight: 1.3,
};

export const ctaWrapper: SxProps<Theme> = {
  py: { xs: 16, md: 24 },
  minHeight: { xs: "60vh", md: "75vh" },
  display: "flex",
  alignItems: "center",
  textAlign: "center",
  background: "#0a0f1e",
  position: "relative",
  overflow: "hidden",
};

export const ctaVideo: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  zIndex: 0,
};

export const ctaDarkOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background: "rgba(8,12,20,0.30)",
  zIndex: 1,
  pointerEvents: "none",
};

export const ctaRadialOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background: "radial-gradient(ellipse 70% 60% at 50% 50%, rgba(0,0,0,0.68) 0%, rgba(0,0,0,0) 75%)",
  zIndex: 1,
  pointerEvents: "none",
};

export const ctaEyebrow: SxProps<Theme> = {
  mb: 3,
  fontSize: { xs: "0.7rem", md: "0.75rem" },
  fontWeight: 600,
  letterSpacing: "0.2em",
  textTransform: "uppercase",
  color: "#38bdf8",
  fontFamily: "'Barlow', sans-serif",
};

export const ctaHeadline: SxProps<Theme> = {
  color: "white",
  mb: 2,
  fontSize: { xs: "2.5rem", md: "3.5rem", lg: "4.5rem" },
  letterSpacing: "-0.02em",
  fontWeight: 800,
  lineHeight: 1.15,
};

export const ctaBody: SxProps<Theme> = {
  color: "rgba(255,255,255,0.82)",
  mb: 5,
  fontWeight: 400,
  fontSize: { xs: "1rem", md: "1.15rem" },
  lineHeight: 1.7,
};

export const ctaOutlinedButton: SxProps<Theme> = {
  color: "white",
  bgcolor: "transparent",
  border: "1px solid rgba(255,255,255,0.25)",
  borderRadius: "50px",
  px: 4,
  py: 1.5,
  "&:hover": {
    borderColor: "rgba(255,255,255,0.5)",
    bgcolor: "transparent",
  },
};

export const socialProofSymbol: SxProps<Theme> = {
  position: "absolute",
  top: "50%",
  left: "50%",
  width: { xs: "70vw", md: "50vw" },
  opacity: 0.12,
  userSelect: "none",
  pointerEvents: "none",
  transition: "transform 1.2s ease",
  zIndex: 0,
  filter: "grayscale(1)",
};

export const howItWorksPrevButton: SxProps<Theme> = {
  border: "1px solid",
  width: 44,
  height: 44,
  flexShrink: 0,
  "&:hover": {
    background: "rgba(56,189,248,0.08)",
    boxShadow: "0 0 18px rgba(56,189,248,0.55), 0 0 36px rgba(56,189,248,0.25)",
  },
  "&.Mui-disabled": {
    color: "rgba(255,255,255,0.2)",
  },
};

export const howItWorksNextButton: SxProps<Theme> = {
  border: "1px solid",
  width: 44,
  height: 44,
  flexShrink: 0,
  "&:hover": {
    background: "rgba(56,189,248,0.08)",
    boxShadow: "0 0 18px rgba(56,189,248,0.55), 0 0 36px rgba(56,189,248,0.25)",
  },
  "&.Mui-disabled": {
    color: "rgba(255,255,255,0.2)",
  },
};
